import React from 'react'

export default function Range({ amount, setAmount }) {
	return (
		<input
			type="range"
			min="1"
			max="20"
			defaultValue="10"
			onInput={(e) => {
				setAmount(parseInt(e.target.value))
			}}
		/>
	)
}
